import React from 'react';
import createReactClass from 'create-react-class';

import ModalAlert from '../modal/modal_alert';
import ModalConfirm from '../modal/modal_confirm';
import ModalLoader from '../modal/modal_loader';
import JoinRequest from '../modal/circle/join_request_from_box';
import EventCreateRequest from '../modal/circle/event_create_request';

//circle_join_request_form_bar_2019の派生版
//join_request_2019ではなくjoin_request_from_boxをimportに変更したもの。

export default createReactClass({
  displayName: 'Root',
  getInitialState() {
    return {
      isLoading: false,
      isFollowed: false,
      isJoinRequestSent: false,
      createdMessage: {},
      childCircleId: '',
    };
  },
  componentDidMount() {
    this.getCurrentStatusFromServer();
  },
  getCurrentStatusFromServer() {
    const { circleId } = this.props;
    this.setState({
      isLoading: true,
    });
    $.ajax({
      type: 'GET',
      url: '/api/circle/current_status',
      cache: false,
      data: {
        circle_id: circleId,
      },
    })
      .done(
        function (data) {
          this.setState({
            isFollowed: data.isFollowed,
            isLoading: data.isMember,
            isJoinRequestSent: data.isJoinRequestSent,
            isRecruiting: data.isRecruiting,
            userSignedIn: data.userSignedIn,
          });
        }.bind(this)
      )
      .fail(function () {}.bind(this));
  },
  followCircleToServer() {
    const { circleId } = this.props;
    $.ajax({
      type: 'POST',
      url: '/api/user/follow_circle',
      cache: false,
      headers: {
        'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content,
      },
      data: {
        circle_id: circleId,
        authenticity_token: $('#authenticity_token').val(),
      },
    })
      .done(
        function () {
          if (typeof window === 'undefined')
            window.location.href =
              '/my_circle/' + circleId.toString() + '/follow_complete';
          this.setState({
            isFollowed: true,
            isFollowLoading: false,
          });
        }.bind(this)
      )
      .fail(
        function (xhr) {
          switch (xhr.responseJSON) {
            case 1:
              this.alreadyFollowedAlert.openModal();
              break;
            case 2:
              this.alreadyMemberAlert.openModal();
              break;
            case 3:
              this.disableErrorAlert.openModal();
              break;
            default:
              switch (xhr.status) {
                case 0:
                  this.networkErrorAlert.openModal();
                  break;
                default:
                  this.systemErrorAlert.openModal();
                  break;
              }
              break;
          }
        }.bind(this)
      );
  },
  unfollowCircleToServer() {
    const { circleId } = this.props;
    this.setState({
      isFollowLoading: true,
    });
    $.ajax({
      type: 'POST',
      cache: false,
      url: '/api/user/unfollow_circle',
      headers: {
        'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content,
      },
      data: {
        circle_id: circleId,
      },
    })
      .done(
        function () {
          this.unfollowCompleteAlert.openModal();
          this.setState({
            isFollowed: false,
            isFollowLoading: false,
          });
        }.bind(this)
      )
      .fail(
        function (xhr) {
          switch (xhr.status) {
            case 0:
              this.networkErrorAlert.openModal();
              break;
            default:
              this.systemErrorAlert.openModal();
              break;
          }
          this.setState({
            isFollowLoading: false,
          });
        }.bind(this)
      );
  },
  handleFollowButton(e) {
    const { userSignedIn, isFollowed } = this.state;
    if (userSignedIn) {
      e.preventDefault();
      if (isFollowed) {
        this.unfollowConfirm.openModal();
      } else {
        this.followComfirm.openModal();
      }
    }
  },
  handleCreateAccountButton() {
    location.href =
      '/users/sign_up/?rurl=' +
      encodeURI(
        '/circle/' +
          this.props.circleId +
          '&rmessage=ログインしました。メンバー申請ボタンを押してください。'
      );
  },
  render() {
    const { userSignedIn, isLoading, isJoinRequestSent, isRecruiting } =
      this.state;
    if (isLoading) {
      return <div />;
    }
    return (
      <div>
        <div className="mb-2">
          {this.state.userSignedIn && this.props.isJoinButtonOn ? (
            <div>
              <JoinRequest
                circleId={this.props.circleId}
                currentUser={this.props.currentUser}
                isJoinRequestSent={isJoinRequestSent}
                isRecruiting={isRecruiting}
                userSignedIn={userSignedIn}
                isRequestRequired={this.props.isRequestRequired}
                isSnsRequired={this.props.isSnsRequired}
                isReloadRequired={this.props.isReloadRequired}
                isButtonDisplay={true}
                isNativeJoinRequest={this.props.isNativeJoinRequest}
              />
            </div>
          ) : (
            ''
          )}
        </div>
        <ModalAlert
          ref={(c) => {
            this.signInAlert = c;
          }}
          title="ログイン"
          content="この操作にはログインまたは会員登録が必要です。"
        />
        <ModalAlert
          ref={(c) => {
            this.followCompleteAlert = c;
          }}
          title="フォロー"
          content="このサークルをフォローしました。"
        />
        <ModalConfirm
          ref={(c) => {
            this.followComfirm = c;
          }}
          title="フォロー"
          content="このサークルをフォローしますか？"
          approveFunc={this.followCircleToServer}
        />
        <ModalAlert
          ref={(c) => {
            this.unfollowCompleteAlert = c;
          }}
          title="フォロー"
          content="このサークルのフォローを解除しました。"
        />
        <ModalConfirm
          ref={(c) => {
            this.unfollowConfirm = c;
          }}
          title="フォロー"
          content="このサークルのフォローを解除しますか？"
          approveFunc={this.unfollowCircleToServer}
        />
        <ModalAlert
          ref={(c) => {
            this.systemErrorAlert = c;
          }}
          title="エラー"
          content="時間を置いてもう一度試すか、運営にお問い合わせください。"
        />
        <ModalAlert
          ref={(c) => {
            this.networkErrorAlert = c;
          }}
          title="エラー"
          content="ネットワークエラーが発生しました。ネットワークの接続を確認し、もう一度試してください。"
        />
        <ModalAlert
          ref={(c) => {
            this.alreadyFollowedAlert = c;
          }}
          title="エラー"
          content="すでにフォローしています。"
        />
        <ModalAlert
          ref={(c) => {
            this.disableErrorAlert = c;
          }}
          title="エラー"
          content="このサークルをフォローする権限がありません。"
        />
        <ModalLoader
          ref={(c) => {
            this.modalLoader = c;
          }}
        />
      </div>
    );
  },
});
